const SidebarData = [
  {
    label: "",
    isMainMenu: true,
  },
  {
    label: "Dashboard",
    icon: "mdi mdi-home-variant-outline",
    url: "/dashboard",
    issubMenubadge: true,
  },
  {
    label: "Messages",
    icon: "mdi mdi-message-text-outline",
    url: "/messages",
    issubMenubadge: true,
  },
];
export default SidebarData;
